module.exports = __webpack_public_path__ + "static/media/alicante-11.178eff09.jpg";